if (!customElements.get('custom-full-360-view')) {
  class Custom360View extends HTMLElement {

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.handle = this.dataset.handle;

      this.bindEvents();
      this.applyInitialActiveState();
      this.bindDownloadButton();

      // MOBILE LAYOUT FIX
      this.handleMobileLayout();

      // LISTEN FROM CTA → 360
      document.addEventListener('variant:change', (e) => {
        if (e.detail.source === '360') return;

        const variantId = e.detail.variantId;

        const target = this.querySelector(
          `.c360-swatch-item[data-variant-id="${variantId}"]`
        );

        if (target) {
          target.click();
        }
      });
    }

    // -------------------------
    // SWATCH EVENTS
    // -------------------------
    bindEvents() {
      this.querySelectorAll('.c360-swatch-item').forEach(el => {
        el.addEventListener('click', (e) => {
          const parent = e.currentTarget;

          const id = parent.dataset.variantId;
          const color = parent.dataset.variantColor;

          if (!id) return;

          this.updateActiveState(parent);
          this.updateVariant(id, color);

          // DISPATCH TO CTA
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: {
              variantId: id,
              source: '360'
            }
          }));
        });
      });
    }

    updateActiveState(activeEl) {
      this.querySelectorAll('.c360-swatch-item').forEach(el => {
        el.classList.remove('active');
      });

      activeEl.classList.add('active');

      const color = activeEl.dataset.variantColor;
      const pill = activeEl.querySelector('.c360-pill');

      if (pill && color) {
        pill.style.background = color;
      }
    }

    applyInitialActiveState() {
      const active = this.querySelector('.c360-swatch-item.active');

      if (active) {
        const color = active.dataset.variantColor;
        const pill = active.querySelector('.c360-pill');

        if (pill && color) {
          pill.style.background = color;
        }
      }
    }

    // -------------------------
    // DOWNLOAD BUTTON
    // -------------------------
    bindDownloadButton() {
      const btn = this.querySelector('.c360-download-btn');
      if (!btn) return;

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const url = btn.getAttribute('href');
        if (!url) return;

        const fileName = url.split('/').pop().split('?')[0];

        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', fileName || 'download');
        a.setAttribute('rel', 'noopener');

        document.body.appendChild(a);
        a.click();
        a.remove();
      });
    }

    // -------------------------
    // MOBILE LAYOUT HANDLER
    // -------------------------
    handleMobileLayout() {
      if (window.innerWidth > 768) return;

      const container = this.querySelector('.c360-variants');
      if (!container) return;

      // prevent duplicate wrapper
      if (container.querySelector('.c360-mobile-wrap')) return;

      const separators = container.querySelectorAll('.c360-separator');
      const swatches = container.querySelectorAll('.c360-swatch-item');
      const downloadBtn = container.querySelector('.c360-download-btn');
      const price = container.querySelector('.c360-price');

      if (!swatches.length) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'c360-mobile-wrap';

      // insert wrapper after price
      if (price) {
        price.insertAdjacentElement('afterend', wrapper);
      } else {
        container.appendChild(wrapper);
      }

      // -------------------------
      // HANDLE SEPARATORS
      // -------------------------
      let firstSeparator = null;
      let secondSeparator = null;

      if (separators.length >= 2) {
        firstSeparator = separators[0];
        secondSeparator = separators[1];
      }

      // FIX FIRST SEPARATOR (position + hide)
      if (firstSeparator && price) {
        price.insertAdjacentElement('afterend', firstSeparator);
        firstSeparator.style.display = 'none';
      }

      // move swatches
      swatches.forEach(el => wrapper.appendChild(el));

      // PLACE SECOND SEPARATOR ABOVE BUTTON
      if (downloadBtn) {
        if (secondSeparator) {
          wrapper.appendChild(secondSeparator);
        }
        wrapper.appendChild(downloadBtn);
      }
    }

    // -------------------------
    // LOADER
    // -------------------------
    showLoader() {
      this.classList.add('loading');
    }

    hideLoader() {
      this.classList.remove('loading');
    }

    // -------------------------
    // VARIANT UPDATE
    // -------------------------
    updateVariant(id, color) {
      const url = `/products/${this.handle}?variant=${id}&section_id=${this.sectionId}`;
      const container = this;

      const height = container.offsetHeight;
      container.style.height = height + 'px';

      this.showLoader();

      fetch(url)
        .then(res => res.text())
        .then(htmlText => {
          const html = new DOMParser().parseFromString(htmlText, 'text/html');
          const updated = html.querySelector('custom-full-360-view');

          if (updated) {
            setTimeout(() => {

              this.innerHTML = updated.innerHTML;

              this.bindEvents();
              this.bindDownloadButton();

              // re-apply mobile layout
              this.handleMobileLayout();

              if (window.CI360) {
                try {
                  window.CI360.destroy && window.CI360.destroy();
                } catch (e) {}

                window.CI360.init();
              }

              this.applyInitialActiveState();

              this.hideLoader();

              setTimeout(() => {
                this.style.height = 'auto';
              }, 400);

            }, 200);
          }

          history.replaceState(null, '', `?variant=${id}`);
        })
        .catch(err => {
          console.error('Variant load error:', err);
          this.hideLoader();
        });
    }
  }

  customElements.define('custom-full-360-view', Custom360View);
}